import React from 'react';
import manualTestingIcon from '@images/icons/manual-testing.svg';
import autoTestingIcon from '@images/icons/auto-testing.svg';
import seleniumIcon from '@images/icons/selenium-icon.svg';
import appiumIcon from '@images/icons/appium-icon.svg';
import jasminIcon from '@images/icons/jasmin.svg';
import jMeterIcon from '@images/icons/jMater.svg';
import cypressIcon from '@images/icons/cypress.svg';
import postmanIcon from '@images/icons/postman.svg';

import { StaticImage } from 'gatsby-plugin-image';

export const howWeWorkData = [
	{
		icon: manualTestingIcon,
		title: 'Manual testing',
		content: (
			<>
				<p>
					This is the most fundamental testing process. Thanks to manual
					testing, you can find the software's visible and hidden defects and
					identify unexpected behavior or bug.
				</p>
				<p className="pt-3">
					Our team of experts writes and plans test cases. Testers use test
					plans, test cases, or test scenarios to test software to ensure
					testing completeness.
				</p>
			</>
		),
	},
	{
		icon: autoTestingIcon,
		title: 'Automation testing',
		content: (
			<p>
				There are specific tests via automation tools. It saves your time and
				makes Our QA team creates cases and runs cross-browser UI tests by
				simulating real user actions.
			</p>
		),
	},
	{
		icon: '/images/icons/testing-icon.svg',
		title: 'Software Quality Control',
		content: (
			<p>
				To be sure about the product, we provide a fully controlled process. It
				is a crucial action during the testing stage of development. SOC checks
				whether a software component or supporting artifact meets requirements.
				It includes reviews and testing levels.
			</p>
		),
	},
];

export const weWorkWithData = [
	{
		icon: seleniumIcon,
		name: 'Selenium',
	},
	{
		icon: jasminIcon,
		name: 'Jasmin',
	},
	{
		icon: jMeterIcon,
		name: 'jMeter',
	},
	{
		icon: appiumIcon,
		name: 'Appium',
	},
	{
		icon: cypressIcon,
		name: 'Cypress',
	},
	{
		icon: postmanIcon,
		name: 'Postman',
	},
];

export const awardsData = [
	{
		icon: (
			<StaticImage
				src="../images/icons/awards/top100clutch.webp"
				alt="Bild der Top 100 Unternehmen mit dem schnellsten Wachstum"
				placeholder="blurred"
			/>
		),
		name: 'Top 100 Unternehmen mit dem schnellsten Wachstum',
	},
	{
		icon: (
			<StaticImage
				src="../images/icons/awards/topDevelopersAustria.webp"
				alt="Bild der Top-Entwickler in Österreich"
				placeholder="blurred"
			/>
		),
		name: 'Top-Entwickler in Österreich',
	},
	{
		icon: (
			<StaticImage
				src="../images/icons/awards/top100iotCompanies.webp"
				alt="Bild der Top IoT Unternehmen 2023"
				placeholder="blurred"
			/>
		),
		name: 'Top IoT Unternehmen 2023',
	},
	{
		icon: (
			<StaticImage
				src="../images/icons/awards/iotPoland.webp"
				alt="Bild der am häufigsten bewerteten IoT Unternehmen in Polen"
				placeholder="blurred"
			/>
		),
		name: 'Am häufigsten bewertete IoT Unternehmen in Polen',
	},
];
